import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const FacebookColor = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <linearGradient
        id="facebook-color-gradient"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(90)"
      >
        <stop offset="0" stopColor="#4AA7DD" />
        <stop offset="1" stopColor="#3965AF" />
      </linearGradient>
      <path
        fill="url(#facebook-color-gradient)"
        d="M16.935,38.388C8.113,36.81,1.426,29.194,1.426,20C1.426,9.784,9.784,1.426,20,1.426
        S38.574,9.784,38.574,20c0,9.194-6.687,16.81-15.509,18.388l-1.022-0.836h-4.086L16.935,38.388z"
      />
      <path
        fill="#FFFFFF"
        d="M27.244,25.201L28.08,20h-4.922v-3.622c0-1.486,0.557-2.6,2.786-2.6h2.415V9.041
        c-1.3-0.186-2.786-0.371-4.086-0.371c-4.272,0-7.244,2.6-7.244,7.244V20h-4.644v5.201h4.644v13.095
        c1.022,0.186,2.043,0.279,3.065,0.279c1.022,0,2.043-0.093,3.065-0.279V25.201H27.244z"
      />
    </StyledSvg>
  );
};
